import { render } from "./productManagerView.vue?vue&type=template&id=3318a903"
import script from "./productManagerView.vue?vue&type=script&lang=js"
export * from "./productManagerView.vue?vue&type=script&lang=js"

import "./productManagerView.vue?vue&type=style&index=0&id=3318a903&lang=less"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__